// extracted by mini-css-extract-plugin
module.exports = {"header-bg-image":"h","headerBgImage":"h","header-bg":"i","headerBg":"i"};